if (!customElements.get("product-cross-sellers")) {
  class ComponentCrossSellers extends HTMLElement {
    constructor() {
      super();

      this.crossSellerData = JSON.parse(
        this.querySelector('[type="application/json"][data-cross-sellers-json]')
          .textContent
      );
      this.mainElement = this.closest(".product-main-element");
      this.btnsAdd = this.querySelectorAll(".cross-sellers .btn-add");
      this.btnsRemove = this.querySelectorAll(".cross-sellers .btn-remove");

      this.initButtons();
    }

    initButtons() {
      this.btnsAdd.forEach((btnAdd) => {
        btnAdd.addEventListener("click", (event) => {
          event.preventDefault();
          this.addProduct(
            event.currentTarget.closest(".cross-sellers").dataset.product
          );
        });
      });
      this.btnsRemove.forEach((btnRemove) => {
        btnRemove.addEventListener("click", (event) => {
          event.preventDefault();
          this.removeProduct(
            event.currentTarget.closest(".cross-sellers").dataset.product
          );
        });
      });
    }

    getCrossSellers() {
      return this.mainElement.dataset.crossSellers
        ? this.mainElement.dataset.crossSellers
            .split(",")
            .map((crossSeller) =>
              this.crossSellerData.find(
                (crossSellerData) => parseInt(crossSellerData.productId) === parseInt(crossSeller)
              )
            )
        : [];
    }

    checkButtonState(id) {
      if (!this.mainElement.dataset.crossSellers) {
        this.querySelector('.product-card.cross-sellers').classList.remove('add')
        return;
      }
      if (this.mainElement.dataset.crossSellers.split(',').map(x => parseInt(x)).includes(parseInt(id))) {
        this.querySelector('.product-card.cross-sellers').classList.add('added')
      } else {
        this.querySelector('.product-card.cross-sellers').classList.remove('added')
      }
    }

    addProduct(productId) {
      this.mainElement.dataset.crossSellers = this.mainElement.dataset.crossSellers
        ? [...this.mainElement.dataset.crossSellers.split(","), productId].join(",")
        : productId;
      this.updateCrossSellers();
    }

    removeProduct(productId) {
      this.mainElement.dataset.crossSellers = this.mainElement.dataset.crossSellers
        ? this.mainElement.dataset.crossSellers
            .split(",")
            .filter((crossSeller) => parseInt(crossSeller) != parseInt(productId))
            .join(",")
        : "";
      this.updateCrossSellers();
    }

    clearCrossSellers() {
      let crossSellersProducts = this.querySelectorAll(".cross-sellers");
      crossSellersProducts.forEach((crossSellersProduct) =>
        crossSellersProduct.classList.remove("added")
      );
      let crossSellersAddedProduct = this.mainElement.querySelectorAll(".cross-sellers-product");
      crossSellersAddedProduct.forEach((product) => product.remove());
    }

    getCurrentExtraAddOns() {
      let crossSellers= this.mainElement.dataset.crossSellers
        ? this.mainElement.dataset.crossSellers.split(",")
        : [];
      return crossSellers.map((crossSeller) =>
        this.crossSellerData.find(
          (crossSellerData) => parseInt(crossSellerData.productId) === parseInt(crossSeller)
        )
      );
    }

    updateCrossSellers() {
      this.clearCrossSellers();

      let crossSellers= this.mainElement.dataset.crossSellers
        ? this.mainElement.dataset.crossSellers.split(",")
        : [];
      crossSellers.forEach((productId, indexAddOn) => {

        let cardSeller = this.querySelector(
            `.cross-sellers[data-product="${productId}"]`
        );
        let checkedInput = cardSeller.querySelector('input[type="radio"]:checked')

        if (!checkedInput || (checkedInput && checkedInput.dataset.available === 'true')) {
          cardSeller.classList.add("added");
          let inputElExtra = document.createElement("input");
          inputElExtra.type = "hidden";
          inputElExtra.name = `items[${indexAddOn + 4}][id]`;
          inputElExtra.value = productId;
          inputElExtra.classList.add(`cross-sellers-${productId}`);
          inputElExtra.classList.add(`cross-sellers-product`);
          this.mainElement.querySelector("form").appendChild(inputElExtra);
        }

      });
      this.mainElement.dispatchEvent(
        new CustomEvent("crossSellersUpdated", {
          detail: crossSellers.map((crossSeller) =>
            this.crossSellerData.find(
              (crossSellerData) => parseInt(crossSellerData.productId) === parseInt(crossSeller)
            )
          ),
        })
      );
    }
  }
  customElements.define("product-cross-sellers", ComponentCrossSellers);
}

if (!customElements.get("cross-sellers-added")) {
  class ComponentCrossSellersAdded extends HTMLElement {
    constructor() {
      super();

      this.mainElement = document.querySelector(".product-main-element");
      this.crossSellersMainElement = document.querySelector("product-cross-sellers");
      this.crossSellersList = this.querySelector(".cross-sellers-list");
      this.initListeners();
    }

    initListeners() {
      this.mainElement.addEventListener("crossSellersUpdated", (event) => {
        if (event.detail.length > 0) {
          this.classList.remove("visually-hidden");
        } else {
          this.classList.add("visually-hidden");
        }
        this.updateButtons(event.detail);
      });
    }

    updateButtons(products) {
      let buttons = this.querySelectorAll(".btn-added");
      buttons.forEach((button) => button.remove());
      products.forEach((product) => {
        let buttonEl = document.createElement("button");
        buttonEl.classList.add("flex", "align-items-center", "btn-added");
        buttonEl.ariaLabel = `Remove {title} from cart`.replace(
          "{title}",
          product.title
        );
        buttonEl.innerHTML = `<div>
          <svg aria-hidden="true" role="icon" class="icon icon-minus" viewBox="0 0 32 32"><path d="M1.8,16H30.2"/></svg></div>
          <span>${product.title}</span>`;
        buttonEl.dataset.product = product.productId;
        this.crossSellersList.appendChild(buttonEl);
      });
      this.initButtons();
    }
    initButtons() {
      let buttonsEl = this.querySelectorAll(".btn-added");
      buttonsEl.forEach((buttonEl) => {
        buttonEl.addEventListener("click", (event) => {
          event.preventDefault();
          this.crossSellersMainElement.removeProduct(
            event.currentTarget.dataset.product
          );
        });
      });
    }
  }
  customElements.define("cross-sellers-added", ComponentCrossSellersAdded);
}
